import styled from 'styled-components';
import {device} from '../../styled/device';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  & > div {
    margin-left: 13px;
    margin-top: -4px;
    color: #9696b9;
    font-family: ProximaNova-Bold, sans-serif;
    font-size: 14px;
    text-transform: uppercase;
    opacity: 0.5;

    @media (max-width: ${device.tablet}) {
      font-size: 18px;
    }
  }
`;
